
import { defineComponent } from "vue";

import TokenService from "@/services/TokenService";
import ResponseData from "@/_models/ResponseData";

import { Helper } from "@/utils/Helper";
import store from "@/store/index";

export default defineComponent({
  data: function () {
    return {
      fileName: "",
      previewImage: "",

      imageFile: "",
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
    };
  },
  name: "uploadTokenPhoto",

  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },

    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },

    removeFile() {
      this.imageFile = null;
      this.previewImage = null;
    },

    updateImage() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.tokenId !== undefined) {
        let tokenId = this.$route.params.tokenId.toString();
        let formData = new FormData();

        if (this.imageFile !== "") {
          formData.append("logoStream", this.imageFile[0]);

          TokenService.updateTokenDetails(tokenId, this.userData.userId, this.jwtToken, 'testnet', formData)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
              this.tokenName = this.tokenTitle;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
              console.log(error.response);
            });
        }
      }
    },
  },
});
